<template>
  <div class="space-top4 div-center">
    <a-icon type="loading" style="fontSize:48px;" />
  </div>
</template>


<script>
export default {
  name: "callback",
  mounted() {
    this.$auth.process_authorize_response();
  }
};
</script>